import * as types from "../gql/graphql";

export function formatStudent(st: types.Fs_StudentsEdge): any {

  const dobParts = st.node?.DOB ? st.node.DOB.split('-') : [];
  // Month is 0-indexed in JavaScript Date object, so subtract 1 from the month
  const DOB = new Date(dobParts[0], dobParts[1] - 1, dobParts[2]); // Leave as JS Date, to be used in primereact Calendar component

  const subsetSt = {
    nodeId: st.node.nodeId,
    id: st.node.id,
    FirstName: st.node.FirstName,
    LastName: st.node.LastName,
    Email: st.node.Email,
    DOB: DOB,
    Height: st.node.Height,
    Weight: st.node.Weight,
    AddrStreet: st.node.AddrStreet,
    AddrTown: st.node.AddrTown,
    AddrZip: st.node.AddrZip,
    AddrState: st.node.AddrState,
    Mobile: st.node.Mobile,
    EnrolementDate: st.node.EnrolementDate,
    MedCondFlag: st.node.MedCondFlag,
    MedCondDescr: st.node.MedCondDescr,
    ExpLevel: st.node.ExpLevel,
    HasEquipment: st.node.HasEquipment,
    Notes: st.node.Notes,
    RegisteredBy: st.node.RegisteredBy,
    RegistrationState: st.node.RegistrationState
  };
  return subsetSt;
}
